import { TwilioLogType } from '@hakimo-ui/hakimo/types';
import { LabelType } from '@hakimo-ui/shared/ui-base';

export const isSmsLog = (update: {
  twilio_log_type?: TwilioLogType;
}): boolean => update.twilio_log_type === TwilioLogType.Twilio_SMS;

export const getSMSStatusLabelType = (status: string): LabelType => {
  switch (status?.toLowerCase()) {
    case 'delivered':
    case 'read':
      return 'success';
    case 'failed':
    case 'undelivered':
    case 'canceled':
      return 'error';
    case 'sent':
    case 'queued':
    case 'sending':
    case 'accepted':
      return 'info';
    default:
      return 'default';
  }
};
